<template>
  <div class="auth-container">
    <EnterEmail v-if="currentStep === Steps.EnterEmail" @submitEmail="onSubmitEmail" @noAccount="onNoAccount"></EnterEmail>
    <EnterCode v-else-if="currentStep === Steps.EnterCode" :email="currentEmail" @submitCode="onSubmitCode" @back="onBack"></EnterCode>
    <EnterPii v-else-if="currentStep === Steps.EnterPii" :email="currentEmail" @submitPii="onSubmitPii" @back="onBack"></EnterPii>
    <LanguagePicker class="language-picker"></LanguagePicker>
  </div>
</template>

<script setup lang="ts">
import LanguagePicker from '@/components/global/LanguagePicker.vue';
import EnterCode from './partials/EnterCode.vue';
import EnterEmail from './partials/EnterEmail.vue';
import EnterPii from './partials/EnterPii.vue';

const router = useRouter();
const route = useRoute();

enum Steps {
  EnterEmail = 1,
  EnterCode = 2,
  EnterPii = 3,
}

const currentStep = ref<Steps>(Steps.EnterEmail);
const currentEmail = ref<string>(null);

const isTalentPage = computed(() => {
  return window.location.host.includes('game');
});

const isExperiencePage = computed(() => {
  return window.location.host.includes('experience');
});

function onSubmitEmail(email: string) {
  currentEmail.value = email;
  currentStep.value += 1;
}

function onNoAccount(email: string) {
  currentEmail.value = email;
  if (route.query.invitation_id) {
    currentStep.value = Steps.EnterPii;
  } else {
    currentStep.value = Steps.EnterEmail;
  }
}

async function onSubmitCode() {
  const redirectUrl = localStorage.getItem('redirectUrl');

  if (route.query.invitation_id) {
    await router.push({
      path: '/join',
      query: {
        invitation_id: route.query.invitation_id
      },
    });
  } else if (redirectUrl && redirectUrl !== '/auth') {
    const url = new URL(redirectUrl, window.location.origin);
    await router.push({
      path: redirectUrl,
      query: Object.fromEntries(url.searchParams),
    });
  } else {
    console.log('No redirect URL found');
    if (isTalentPage.value) {
      await router.push({ name: "game-home" })
    } else if (isExperiencePage.value) {
      await router.push({ name: 'home' });
    } else {
      await router.push({ name: 'root' });
    }
  }
}

function onSubmitPii(pii: {
  email: string,
  firstName: string,
  lastName: string,
}) {
  currentStep.value = Steps.EnterCode;
}

function onBack() {
  currentStep.value = Steps.EnterEmail;
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.auth-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.language-picker {
  position: absolute;
  top: 20px;
  left: 20px;

  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--secondary-color);
  border-radius: 4px;

  @media screen and (max-width: $medium-screen) {
    ::v-deep(.btn.sm) {
      font-size: 12px;
      padding: 6px 14px;
    }
  }

  .btn.secondary {
    background-color: var(--secondary-color);
    color: var(--black-color);

    &:hover {
      background-color: $secondary-800-color;
    }

    &:active {
      background-color: $secondary-600-color;
    }
  }
}
</style>